<template>
    <div class="widget">
        <div class="h4">{{ title }}</div>
        <ul class="footerLink">
            <li v-for="(link, index) in links" :key="index">
                <router-link :to="{ name: link.to}">{{ link.name}}</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'widget',
  props: ['title', 'links']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget.vue